import moment from "moment";
import { FlagIcon } from "react-flag-kit";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import cancelImg from "../../assets/images/schedule/img_class-scheduled_cancel.png";

import { SelectButtons } from "./styles";

function CancelDialog({
  cancelSubmit,
  allSeqClasses,
  openCancelAlert,
  closeCancelAlert,
  recurrentSchedule,
  recurrentScheduleId,
  sequentialScheduleCancelClasses,
}) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [isRecurrent, setIsRecurrent] = useState(false);
  const [message, setMessage] = useState({ value: "", cancelledBy: "lingo", error: false });

  useEffect(() => {
    validRecurrentClassCancel(sequentialScheduleCancelClasses, recurrentScheduleId);
  }, [sequentialScheduleCancelClasses, recurrentScheduleId]);

  const inputChange = (e) => {
    e.preventDefault();

    if (e.target.name === "cancelBy") {
      setMessage({ ...message, cancelledBy: e.target.value });
    } else {
      setMessage({ ...message, value: e.target.value });
    }
  };

  const cancelSubmitHandler = async (e, recurrentSchedule, allRecurrences) => {
    e.preventDefault();

    if (message.value === "" || message.value.length < 1) {
      setMessage({ ...message, value: t("CANCELED_CYCLE") });
    }
    message.value === ""
      ? await cancelSubmit("Cancel By User", message.cancelledBy, recurrentSchedule, allRecurrences).then(
          setMessage({ ...message, value: "Cancel By User", cancelledBy: message.cancelledBy, error: false }),
        )
      : await cancelSubmit(message.value, message.cancelledBy, recurrentSchedule, allRecurrences).then(
          setMessage({ ...message, cancelledBy: message.cancelledBy, error: false }),
        );
  };

  const validRecurrentClassCancel = (sequentialScheduleCancelClasses) => {
    const lisRecurrent = sequentialScheduleCancelClasses.filter((value) => {
      return value.recurrentSchedule === true;
    });
    const isRecurrent = lisRecurrent.length > 0;

    setIsRecurrent(isRecurrent);
  };

  const SequentialClassesCard = () => {
    return (
      <div>
        {sequentialScheduleCancelClasses && sequentialScheduleCancelClasses.length > 0 && (
          <div className="boxModal">
            <h3>{t("SEQUENTIAL_CLASS_MESSAGE")}</h3> <hr />
          </div>
        )}
        <div className="boxModal">
          {allSeqClasses?.timeTotal ? (
            <h3>
              <FlagIcon code={allSeqClasses?.lingoLanguage?.flag} />

              {`${t(decryptIfEncrypted(allSeqClasses?.lingoLanguage?.language?.name).toUpperCase())} • ${
                user?.role === "teacher"
                  ? allSeqClasses?.timeTotal
                  : allSeqClasses?.timeTotal[0] + allSeqClasses?.timeTotal[1]
              }`}
            </h3>
          ) : (
            allSeqClasses?.map((item, i) => (
              <h3 key={i}>
                <FlagIcon code={item?.lingoLanguage?.flag} />

                {`${t(item?.lingoLanguage?.language?.name.toUpperCase())} • ${
                  moment(item?.scheduledDate).format("MM-DD-YYYY") +
                  " • " +
                  moment(item?.scheduledDate + "T" + item?.scheduledStartTime).format("hh:mm a") +
                  " • " +
                  moment(item?.scheduledDate + "T" + item?.scheduledEndTime).format("hh:mm a")
                }`}
              </h3>
            ))
          )}
        </div>

        {!isRecurrent ? (
          <div className="boxModal">
            <hr />
            <h3>{t("CANCEL_ALL_CLASSES_MESSAGE")}</h3>
          </div>
        ) : (
          <div className="boxModal">
            <hr />
            <h3>{t("CANCEL_ALL_FIXED_CLASSES_MESSAGE")}</h3>
          </div>
        )}
      </div>
    );
  };

  const isManager = user?.role === "companyManager" || user?.role === "customerService" || user?.role === "coordinator";
  const unlimited = allSeqClasses?.studentPlan?.plan.unlimited;

  const differenceEmHours = allSeqClasses?.remainingMinutes < 60;

  return (
    <Dialog open={openCancelAlert} onClose={closeCancelAlert} className="cancelDialog">
      <DialogTitle className="dialogTitle dialogTitleWarning">
        {user?.role !== "student" || unlimited
          ? t("CANCEL_CLASS")
          : t(differenceEmHours ? "CANCEL_CLASS_OUT_OF_LIMIT" : "CANCEL_CLASS")}
      </DialogTitle>
      <DialogContent className="dialogContent">
        <img className="dialogImage" src={cancelImg} alt={t("CANCEL_IMAGE")} />
        <form className="dialogForm boxModal">
          <p className={`dialogMessage ${message.error ? "invalid" : ""}`}>
            {user?.role !== "student" || unlimited
              ? t("CANCEL_MESSAGE")
              : t(differenceEmHours ? "CANCEL_MESSAGE_OUT_OF_LIMIT" : "CANCEL_MESSAGE")}
          </p>
          <SequentialClassesCard />
          <br />
          {isManager && (
            <SelectButtons>
              <button
                name="cancelBy"
                onClick={inputChange}
                value="lingo"
                className={message.cancelledBy === "lingo" ? "active" : ""}
              >
                {t("CANCELLED_LINGO")}
              </button>
              <button
                name="cancelBy"
                onClick={inputChange}
                value="student"
                className={message.cancelledBy === "student" ? "active" : ""}
              >
                {t("CANCELLED")}
              </button>
            </SelectButtons>
          )}
          <br />
          <textarea
            className={`dialogInput dialogTextArea ${message.error ? "invalid" : ""}`}
            type="text"
            placeholder={t("CANCEL_PLACEHOLDER")}
            value={message.value}
            onChange={(e) => inputChange(e)}
            required={false}
          />
          <br />
          {recurrentSchedule && <h3 className="dialogMessage pad-top boxModal">{t("CANCEL_MESSAGE_REPEAT")}</h3>}
        </form>
        <br />
      </DialogContent>
      <DialogActions className="dialogActions">
        {!isRecurrent ? (
          <div>
            <button
              type="button"
              className="exitButton modalButton teste"
              onClick={(e) => cancelSubmitHandler(e, true, false)}
            >
              {t("BTN_CANCEL_ONLY_CLASS")}
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <button
              type="button"
              className="exitButton modalButton teste"
              onClick={(e) => cancelSubmitHandler(e, true, false)}
            >
              {t("BTN_CANCEL_ONLY_CLASS")}
            </button>
            {user.role === "student" && (
              <button
                type="button"
                className="exitButton modalButton"
                onClick={(e) => cancelSubmitHandler(e, true, true)}
              >
                {t("BTN_CANCEL_ALL_CLASS")}
              </button>
            )}
          </div>
        )}

        <button type="button" className="cancelButton modalButton" onClick={(e) => closeCancelAlert(e)}>
          {t("BTN_NOT_CANCEL_CLASS")}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelDialog;
